import { PaginatedTaskResponse } from 'src/@types/crs/task';
import { PaginateQuery, paginateQueryToURLParams } from 'src/api/pagination/dtos';
import { apiClient } from 'src/careflow/ph-core/api_client/api_client';
import { convertFilterToPaginateQueryParams } from 'src/utils/gridView';

const baseUrl = '/task';

export const getTasks = async (
  queryParams: PaginateQuery
): Promise<PaginatedTaskResponse | null> => {
  const urlParams = paginateQueryToURLParams(queryParams);
  urlParams.delete('sortBy');
  let sortingBy = '';
  if (queryParams?.sortBy?.length) {
    const [orderBy, direction] = queryParams?.sortBy?.[0];
    sortingBy = `&sortBy=${orderBy}:${direction}`;
  }
  const filters = convertFilterToPaginateQueryParams(queryParams?.filter ?? {});
  const url = `${baseUrl}?${urlParams.toString()}${sortingBy}${filters}`;
  try {
    const response = await apiClient.get<PaginatedTaskResponse>(url);
    return response;
  } catch (error) {
    return null;
  }
};

export const getTasksAndStats = async (
  queryParams: PaginateQuery
): Promise<PaginatedTaskResponse | null> => {
  // Create a deep copy to avoid mutating the original
  const queryCopy = JSON.parse(JSON.stringify(queryParams));
  const urlParams = paginateQueryToURLParams(queryCopy);
  urlParams.delete('sortBy');
  let sortingBy = '';
  if (queryParams?.sortBy?.length) {
    const [orderBy, direction] = queryParams?.sortBy?.[0];
    sortingBy = `&sortBy=${orderBy}:${direction}`;
  }
  const url = `${baseUrl}/stats?${urlParams.toString()}${sortingBy}`;
  try {
    const response = await apiClient.get<PaginatedTaskResponse>(url);
    return response;
  } catch (error: any) {
    return null;
  }
};

export const createTask = async (payload: any): Promise<any> => {
  try {
    const data = await apiClient.post(baseUrl, payload);
    return data;
  } catch (error) {
    return false;
  }
};

export const updateTask = async (payload: any, taskId: string): Promise<any> => {
  try {
    const data = await apiClient.put(`${baseUrl}/${taskId}`, payload);
    return data;
  } catch (error) {
    return false;
  }
};